import * as React from 'react'

import Tick from 'components/_Assets/vendor/flipclock'
import './Flipclock.scss'

interface NumberFlipclockProps {
  startValue: number
  currentValue: number
}

class NumberFlipclock extends React.Component<NumberFlipclockProps, {}> {
  constructor(props: NumberFlipclockProps) {
    super(props)
  }

  public componentDidMount() {
    this.tickInit()
  }

  public componentDidUpdate() {
    return false
  }

  public componentWillUnmount() {
    this.tickDestroy()
  }

  public render() {
    return (
      <div className="srprs-flipclock" ref="counter">
        <div data-layout="horizontal center fit">
          <div className="tick-group">
            <div
              data-key="value"
              data-repeat="true"
              data-transform="arrive(9, .001) -> round -> pad('   ') -> split -> delay"
            >
              <span data-view="flip" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  private tickInit = () => {
    Tick.DOM.create(this.refs.counter, {
      didInit: (tick: any) => {
        tick.value = this.props.startValue
        setTimeout(() => {
          tick.value = this.props.currentValue
        }, 500)
      },
    })
  }

  private tickDestroy = () => {
    if (this.refs.counter) {
      Tick.DOM.destroy(this.refs.counter)
    }
  }
}

export default NumberFlipclock
